import { action, observable } from 'mobx';
import {
  StoreLocatorSidebarPdpData,
  StoreLocatorSidebarState,
  StoreLocatorTab,
  StoreLocatorType,
} from './storeLocatorTypes';

export const storeLocatorSidebarState = observable<StoreLocatorSidebarState>({
  isOpen: false,
  data: null,
  title: '',
  isLoading: false,
});

export const openStoreLocatorSidebar = action(
  ({
    feature = 'fis',
    pdpProps,
    page = 'pdp',
    openTab,
  }: {
    feature: StoreLocatorType;
    pdpProps?: StoreLocatorSidebarPdpData;
    page: 'pdp' | 'cart';
    openTab?: StoreLocatorTab;
  }) => {
    storeLocatorSidebarState.isOpen = true;
    storeLocatorSidebarState.title = getSidebarTitle(feature);
    storeLocatorSidebarState.openTab = openTab;
    storeLocatorSidebarState.data = {
      product: pdpProps?.product,
      selectedVariant: pdpProps?.selectedVariant,
      userSelectedSize: pdpProps?.userSelectedSize,
      storeLocatorType: feature,
      isAvailableOnline: pdpProps?.isAvailableOnline,
      page,
      ...(feature === 'bopis' ? { storeSelectionEnabled: true } : {}),
    };
    storeLocatorSidebarState.isLoading = false;
  }
);

export const closeStoreLocatorSidebar = action(() => {
  storeLocatorSidebarState.isOpen = false;
  storeLocatorSidebarState.data = null;
  storeLocatorSidebarState.title = '';
  storeLocatorSidebarState.isLoading = false;
});

export const setStoreLocatorSidebarIsLoadingState = action((newValue: boolean) => {
  storeLocatorSidebarState.isLoading = newValue;
});

function getSidebarTitle(feature: string) {
  switch (feature) {
    case 'bopis':
      return 'Pick up in store';
    case 'sdd':
      return 'Shipping & Returns';
    default:
      return 'Find in Store';
  }
}
